import { IAction } from '@/store/types/action'
import { IState } from './types'
import {
  CHECK_SUPPLY_INIT,
  CHECK_SUPPLY_SUCCESS,
  CHECK_SUPPLY_ERROR,
 } from './mutations-types'
import { getApi } from '@/api'
import { dataSuppliers } from '@/api/mocks/suppliers'
import config from '../../../../public/config.json'

const searchSupply: IAction<IState, any> = async ({ commit }, supply: string) => {
  commit(CHECK_SUPPLY_INIT)

  const api = getApi()

  try {
    let response: any
    // tslint:disable-next-line:max-line-length
    response = (config.mocks.suppliersMocks || config.mocks.all) ? dataSuppliers : await api.Suppliers.searchSupply(supply)

    commit(CHECK_SUPPLY_SUCCESS, response)
  } catch (error) {
    console.error('An error occurred while fetching suppliers', error)
    commit(CHECK_SUPPLY_ERROR, {error})
  }
}

export default {
  searchSupply,
}
